<template>
  <span>
    <!-- <v-btn small class="mx-1" color="blue" dark @click="showTokens" v-if="role == 'ADMIN'">Tokens</v-btn> -->
    <v-btn tile text class="my-4 px-6 blue" dark height="60" @click="showTokens"
      >Tokens</v-btn
    >
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <!-- <v-card flat tile> -->

      <v-card flat tile>
        <v-toolbar dark color="primary" flat class="px-2">
          <v-toolbar-title>Tokens - {{ view.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-row no-gutters>
            <v-col cols="4"></v-col>
            <v-col cols="5">
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
              >
                <template v-slot:append>
                  <v-icon color="primary">mdi-magnify</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn
                class="primary"
                tile
                width="245"
                height="60"
                text
                @click="dialog2 = true"
                >Create Token</v-btn
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-data-table :headers="headers" :items="tokens" :search="search">
            <template v-slot:item.expDate="{ item }">
              {{ item.expDate | date }}
            </template>
            <template v-slot:item.deleted="{ item }">
              <div :class="[item.deleted ? 'red--text' : '']">
                {{ item.deleted ? "Deleted" : "" }}
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <v-btn
                v-if="!item.deleted"
                tile
                class="primary my-4 px-6"
                height="60"
                text
                @click="copyToken(item._id)"
              >
                <v-icon left dark>mdi-content-copy</v-icon>Copy url
              </v-btn>
              <v-btn
                tile
                class="warning ml-2 my-4 px-6"
                height="60"
                text
                v-if="!item.deleted"
                @click="
                  deletedDialog = true;
                  lockTokenID = item._id;
                "
              >
                <v-icon left>mdi-alert-box</v-icon>Remove
              </v-btn>
              <v-btn
                tile
                class="green ml-2 my-4 px-6"
                height="60"
                text
                dark
                v-if="item.deleted"
                @click="
                  removedeletedDialog = true;
                  lockTokenID = item._id;
                "
              >
                <v-icon left dark>mdi-refresh</v-icon>Restore
              </v-btn>
            </template>
            <template v-slot:item.url="{ item }">
              <p
                :ref="item._id"
                style="max-width: 400px; overflow-x: auto; white-space: nowrap"
                class="custom-scroll-x"
              >
                {{ currentUrl + item._id }}
              </p>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" max-width="600px">
      <v-card>
        <v-form v-model="valid" ref="form">
          <v-card-title>
            <span class="headline">Generate Token</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    label="Name"
                    v-model="requester"
                    required
                    :rules="emailRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    :label="`Duration (days)${
                      role != 'ADMIN' ? ' - max 25' : ''
                    } `"
                    required
                    v-model="daysPeriod"
                    :rules="daysRules"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" text @click="closeDialog2">Close</v-btn>
            <v-btn
              color="primary"
              text
              @click="onGenerateToken"
              :loading="saving"
              >Generate</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog max-width="600" v-model="deletedDialog">
      <v-card>
        <v-card-title class="headline">Remove token?</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            tile
            class="ma-2"
            color="primary"
            @click="deletedDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            tile
            text
            class="primary ma-2"
            @click="onLockToken"
            :loading="pending"
            >Remove</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="600" v-model="removedeletedDialog">
      <v-card>
        <v-card-title class="headline"
          >Restore Token from deleted?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            tile
            class="ma-2"
            color="primary"
            @click="deletedDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            tile
            text
            class="primary ma-2"
            @click="onLockToken"
            :loading="pending"
            >Restore</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Tokens",
  props: ["view"],
  data() {
    return {
      dialog: false,
      dialog2: false,
      search: "",
      requester: "",
      daysPeriod: 7,
      saving: false,
      laoding: false,
      pending: false,
      deletedDialog: false,
      removedeletedDialog: false,
      lockTokenID: "",
      valid: false,
      emailRules: [(v) => !!v || "Email is required"],
      daysRules: [
        (v) => !!v || "Fiels required",
        (v) => v > 0 || "Minimum 0 days",
        (v) => v < 25 || this.role == "ADMIN" || "Maximum 25 days",
      ],
      headers: [
        {
          text: "ID",
          align: "left",
          value: "_id",
        },
        { text: "URL", value: "url" },
        { text: "Description", value: "info" },
        { text: "Token creator", value: "creator" },
        { text: "Exp date", value: "expDate" },
        // { text: "Is deleted", value: "deleted" },
        { text: "", value: "action", sortable: false, align: "right" },
      ],
    };
  },
  computed: {
    ...mapGetters(["tokens", "role", "user"]),
    currentUrl() {
      return window.location.origin + "/#/?t=";
    },
  },
  mounted() {
    if (this.user.superUser) {
      this.headers.splice(5, 0, { text: "Is deleted", value: "deleted" }, 6);
    }
  },
  methods: {
    ...mapActions([
      "createToken",
      "fetchTokensByView",
      "lockToken",
      "setSnackbar",
    ]),
    async showTokens() {
      this.dialog = true;
      this.laoding = true;
      await this.fetchTokensByView(this.view._id);
      this.laoding = false;
    },
    async onGenerateToken() {
      this.$refs.form.validate();
      if (!this.valid) return;
      try {
        this.saving = true;
        const token = await this.createToken({
          viewID: this.view._id,
          info: this.requester,
          days: this.daysPeriod,
        });
        this.saving = false;
        this.dialog2 = false;
        this.daysPeriod = 7;
        this.requester = "";
        this.token = window.location.origin + "?token=" + token.token;
        await this.fetchTokensByView(this.view._id);
        this.setSnackbar({
          text: `Token Generated.`,
        });
      } catch (error) {
        this.saving = false;
      }
    },
    copyToken(element) {
      const range = document.createRange();
      range.selectNode(this.$refs[element]);
      window.getSelection().removeAllRanges(); // clear current selection
      window.getSelection().addRange(range); // to select text
      document.execCommand("copy");
      window.getSelection().removeAllRanges(); // to deselect
      this.setSnackbar({
        text: `Token copied.`,
      });
    },
    closeDialog2() {
      this.requester = "";
      this.dialog2 = false;
    },
    async onLockToken() {
      await this.lockToken(this.lockTokenID);
      this.deletedDialog = false;
      this.removedeletedDialog = false;
      this.setSnackbar({
        text: `Token status changed.`,
      });
    },
  },
};
</script>

<style lang="scss">
.v-data-table-header th {
  border-bottom: 2px solid #ef3f37 !important;
}
</style>
